export const templatesList = [
  "azurill",
  "bronzor",
  "chikorita",
  "ditto",
  "gengar",
  "glalie",
  "kakuna",
  "leafish",
  "nosepass",
  "onyx",
  "pikachu",
  "rhyhorn",
  "snorlax",
  "meowth",
  "quagsire",
  "mudkip",
  "arcanine",
  "flareon",
  "glaceon",
  "espeon",
  // "hariyama",
] as const;

export type Template = (typeof templatesList)[number];
